import React, { ReactElement } from 'react';
import TableRowInternal from '@mui/material/TableRow';
import FormatService from '../../services/format-service';
import useStylesTableRow from './table-row.styles';

const TableRow: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isButton,
    isActive,
    isCompleted,
    withAlignTop,
    id,
    className,
    onClick,
    onTouchEnd,
    onPointerUp,
    onPointerDown,
    children,
  } = props;

  const { classes } = useStylesTableRow();

  const buttonClassName: string | undefined = isButton ? classes.tableRowButton : undefined;
  const completedClassName: string | undefined = isCompleted ? classes.tableRowCompleted : undefined;
  const alignTopClassName: string | undefined = withAlignTop ? classes.tableRowAlignTop : undefined;

  return (
    <TableRowInternal
      selected={isActive}
      id={id}
      className={FormatService.formatClassNames(buttonClassName, completedClassName, alignTopClassName, className)}
      classes={{
        selected: classes.tableRowSelected,
      }}
      onPointerDown={onPointerDown}
      onPointerUp={onPointerUp}
      onTouchEnd={onTouchEnd}
      onClick={onClick}
    >
      {children}
    </TableRowInternal>
  );
});

export default TableRow;
